import { render, staticRenderFns } from "./TrainingCentersPage.vue?vue&type=template&id=048c4b18&scoped=true&"
import script from "./TrainingCentersPage.vue?vue&type=script&lang=js&"
export * from "./TrainingCentersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048c4b18",
  null
  
)

export default component.exports